import { connect } from 'react-redux';

import { logoutUser } from '../../actions/users/logoutUser';
import { renewToken } from '../../actions/users/renewToken';
import { ROUTER_BASE_PATH } from '../../constants/siteConstants';
import { isUserAuthenticated } from '../../selectors/users';
import { openModalError, openModalSession } from '../../utils/modals';
import Session from '../../utils/session';
import SessionTimerContent from './SessionTimerContent';
import Timer from './Timer';

const showWarningModal = async (renewTokenAction, logoutUser, intervalTimer, navigate) => {
  const WARNING_EXPIRATION = 120000;

  const refresh = async () => {
    const oldToken = Session.getAuthenticationToken();
    const response = await renewTokenAction(oldToken);
    const renewTokenResponseData = response;
    if (renewTokenResponseData.token === oldToken) {
      openModalError({
        title: 'Oops...',
        children: 'Algo salió mal. No pudimos renovar tu sesión. Logueate nuevamente',
      });
    }
  };

  const logout = () => {
    logoutUser();
    if (intervalTimer) {
      clearInterval(intervalTimer);
    }
    navigate(ROUTER_BASE_PATH);
  };

  openModalSession({
    title: 'La sesión está por expirar',
    children: <SessionTimerContent timer={WARNING_EXPIRATION} logout={logout} />,
    refresh,
    logout,
  });
};

const SessionTimer = ({ isUserAuthenticated, renewToken, logoutUser }) => {
  if (window.IS_RUNNING_IN_CYPRESS) return null;

  if (!isUserAuthenticated) return null;

  return (
    <Timer showWarningModal={showWarningModal} renewToken={renewToken} logoutUser={logoutUser} />
  );
};

const mapStateToProps = (state) => {
  return {
    isUserAuthenticated: isUserAuthenticated(state),
  };
};

export default connect(mapStateToProps, { renewToken, logoutUser })(SessionTimer);
